// Analytics utility functions and constants

export const getCompletionColor = (rate) => {
  if (rate >= 80) return 'text-green-600';
  if (rate >= 50) return 'text-yellow-600';
  return 'text-red-600';
};

export const getCompletionBg = (rate) => {
  if (rate >= 80) return 'bg-green-100';
  if (rate >= 50) return 'bg-yellow-100';
  return 'bg-red-100';
};

export const getStatusColor = (status) => {
  const colors = {
    // PT-BR canonical (current DB after migration)
    'Não Iniciado': 'bg-gray-200 text-gray-700',
    'Em Andamento': 'bg-blue-100 text-blue-700',
    'Em Espera':    'bg-yellow-100 text-yellow-700',
    'Concluído':    'bg-emerald-100 text-emerald-700',
    'Cancelado':    'bg-red-100 text-red-700',
    // Legacy English (kept for safety)
    'Not Started': 'bg-gray-200 text-gray-700',
    'In Progress': 'bg-blue-100 text-blue-700',
    'On Hold': 'bg-yellow-100 text-yellow-700',
    'On Hold - Agency': 'bg-orange-100 text-orange-700',
    'Completed': 'bg-emerald-100 text-emerald-700',
  };
  return colors[status] || 'bg-gray-200 text-gray-700';
};

export const PROJECT_STATUS_COLORS = {
  'Não Iniciado': { bg: 'bg-gray-300', text: 'text-gray-700', label: 'Não Iniciado' },
  'Em Andamento': { bg: 'bg-blue-500', text: 'text-blue-700', label: 'Em Andamento' },
  'Em Espera':    { bg: 'bg-yellow-500', text: 'text-yellow-700', label: 'Em Espera' },
  'Concluído':    { bg: 'bg-emerald-500', text: 'text-emerald-700', label: 'Concluído' },
  'Cancelado':    { bg: 'bg-red-400', text: 'text-red-700', label: 'Cancelado' },
};

export const TASK_STATUS_COLORS = {
  'not_started': { bg: 'bg-gray-400', label: 'Não Iniciada' },
  'in_progress': { bg: 'bg-blue-500', label: 'Em Andamento' },
  'completed': { bg: 'bg-green-500', label: 'Concluída' },
  'cancelled': { bg: 'bg-red-400', label: 'Cancelada' }
};
